import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import InputMask from 'react-input-mask';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import Select from 'react-select';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function TransferOwnershipModal({
  createTransferApplication,
  getApplicationsList,
  history,
  draftToHtml,
  convertToRaw,
  searchTdnSubdivision,
  createRichTextEditor,
  getOwnerList,
  ownerList,
  transactionCode,
  getTdn,
  formData,
  showData,
  isLoading
}) {

  const setModal = useContext(ModalContext);

  const [form, setForm] = useState({
    rptax_owner_id: "",
    tdn: "",
    for_improvement: 0
  });

  const validateForm = useFormValidator(form, {
    tdn: "required|rptax_tdn",
    rptax_owner_id: "required",
  });

  const handleOnChangeSelect = key => e => {
    setForm({
      ...form,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    getOwnerList();
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(form).join(',')]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...form,
      rptax_transaction_code_id: transactionCode,
      memoranda: draftToHtml(
        convertToRaw(formData.memoranda.getCurrentContent())
      ),
    };

    createTransferApplication(args, () => {
      setModal({ isOpen: false });
      getApplicationsList({}, ({ data }) => {
        history.push(`/rpt/building/applications/${_.get(data, '0.id')}`);
        showData(_.get(data, '0.id'));
      });
    });

    return false;
  };

  const onChange = (e) => {
    return setForm({
      ...form,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const findTdn = (e) => {
    e.preventDefault();
    if (form.for_improvement === 0) {
      searchTdnSubdivision(form.tdn, transactionCode, 0, (building_data) => {
        if (!_.isEmpty(building_data)) {
          Alert.success("Application Found.");
          getTdn(
            { barangay_id: building_data.data.attributes.property_barangay_id },
            ({ data }) => {
              setForm({
                ...form,
                building_application_id: building_data.data.id,
                pin: building_data.data.attributes.pin,
                previous_owner: building_data.data.attributes.rptax_owner_id,
                owner_region_code: _.get(building_data, 'data.included.buildingOwner.attributes.region_name'),
                owner_province_code: _.get(building_data, 'data.included.buildingOwner.attributes.province_name'),
                owner_municipality_code: _.get(building_data, 'data.included.buildingOwner.attributes.municipality_name'),
                owner_barangay_code: _.get(building_data, 'data.included.buildingOwner.attributes.barangay_name'),
                address_line: _.get(building_data, 'data.included.buildingOwner.attributes.address_line'),
                assessed: building_data.data.attributes.appraised_assessed_by,
                new_tdn: data,
              });
            }
          );
        } else {
          Alert.error("No Application Found.")
        }
      });
    } else {
      searchTdnSubdivision(form.tdn, transactionCode, 1, (building_data) => {
        if (!_.isEmpty(building_data)) {
          Alert.success("Application Found.");
          getTdn(
            { barangay_id: building_data.data.attributes.property_barangay_id },
            ({ data }) => {
              setForm({
                ...form,
                building_application_id: building_data.data.id,
                pin: building_data.data.attributes.pin,
                previous_owner: building_data.data.attributes.rptax_owner_id,
                owner_region_code: _.get(building_data, 'data.included.buildingOwner.attributes.region_name'),
                owner_province_code: _.get(building_data, 'data.included.buildingOwner.attributes.province_name'),
                owner_municipality_code: _.get(building_data, 'data.included.buildingOwner.attributes.municipality_name'),
                owner_barangay_code: _.get(building_data, 'data.included.buildingOwner.attributes.barangay_name'),
                address_line: _.get(building_data, 'data.included.buildingOwner.attributes.address_line'),
                assessed: building_data.data.attributes.appraised_assessed_by,
                new_tdn: data,
              });
            }
          );
        } else {
          Alert.error("No Application Found.")
        }
      });
    }
  };

  const ownerOptions = ownerList.map((x) => ({
    label: _.get(x, 'attributes.full_name'),
    value: x.id,
    id: x.id,
  }));

  const onChangeCheckbox = (e) => {
    const for_improvement = +_.get(form, "for_improvement", 0) ? 0 : 1;

    let newValue = e.target.value
    if (e.target.name === "for_improvement") {
      newValue = for_improvement
    }

    setForm({
      ...form,
      [e.target.name]: newValue,
      land_application_id: "",
      building_application_id: "",
      rptax_building_application_id: "",
      td_owner: "",
      td_oct: "",
      td_oct_date: "",
      td_lot_no: "",
      td_block: "",
      td_area: "",
      property_barangay_id: "",
      property_district_id: "",
      property_street: ""
    });
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label className="m-0 text-color font-weight-bold">
            Property To Transfer
          </label>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">TDN/ARP No.
            {validateForm.renderMessage('tdn')}
          </label>
          <div
            className="input-group mb-3 col-12 mt-2"
            style={{ marginLeft: -15 }}
          >
            <InputMask
              className="form-control"
              mask="aa-99999-99999"
              alwaysShowMask
              type="text"
              name="tdn"
              onChange={onChange}
              value={_.get(form, 'tdn')}
            />
            <div className="input-group-append">
              <button
                disabled={
                  _.get(form, 'tdn') === '__-_____-_____' ||
                  _.get(form, 'tdn') === ''
                }
                type="button"
                onClick={findTdn}
                className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
              >
                <span className="icon">
                  <i className="fa fa-lg fa-search" />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="col-6 form-group ml-auto">
          <label htmlFor="last_name" className="form-label">
            For Improvement &nbsp;
          </label>
          <input
            name="for_improvement"
            type="checkbox"
            checked={_.get(form, 'for_improvement')}
            onChange={onChangeCheckbox}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">PIN</label>
          <input
            className="form-control"
            type="text"
            name="pin"
            value={_.get(form, 'pin') || ''}
            disabled
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Owner</label>
          <div>
            <Select
              options={ownerOptions}
              styles={customStyle}
              placeholder="Select Owner"
              value={
                ownerOptions.filter(
                  (item) =>
                    +_.get(form, 'previous_owner') ===
                    +_.get(item, 'id')
                ) || ''
              }
              onChange={handleOnChangeSelect('previous_owner')}
              isDisabled
            />
          </div>
        </div>
        <div className="col-12 mt-2 mb-2">
          <div className="header-modal">
            Address
          </div>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Region
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_region_code"
            onChange={onChange}
            value={_.get(form, 'owner_region_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Province
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_province_code"
            onChange={onChange}
            value={_.get(form, 'owner_province_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Municipality
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_municipality_code"
            onChange={onChange}
            value={_.get(form, 'owner_municipality_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Barangay
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_barangay_code"
            onChange={onChange}
            value={_.get(form, 'owner_barangay_code') || ''}
          />
        </div>
        <div className="col-12 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Unit No. / House No. / Street Name
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="address_line"
            onChange={onChange}
            value={_.get(form, 'address_line') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Assessed By</label>
          <input
            className="form-control"
            type="text"
            name="assessed"
            value={_.get(form, 'assessed') || ''}
            disabled
          />
        </div>

        <div className="col-12 form-group">
          <label className="m-0 text-color font-weight-bold">
            Transfer To
          </label>
        </div>

        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label">
            TDN/ARP No.
          </label>
          <input
            className="form-control"
            type="text"
            name="new_tdn"
            value={_.get(form, 'new_tdn')}
            disabled
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Owner</label> {validateForm.renderMessage('rptax_owner_id')}
          <div>
            <Select
              options={ownerOptions}
              styles={customStyle}
              placeholder="Select Owner"
              value={
                ownerOptions.filter(
                  (item) =>
                    +_.get(form, 'rptax_owner_id') ===
                    +_.get(item, 'id')
                ) || ''
              }
              onChange={handleOnChangeSelect('rptax_owner_id')}
            />
          </div>
        </div>
        <div className="col-12 form-group">
          {createRichTextEditor(
            { key: 'memoranda', label: 'Memoranda:' },
            { minLength: 3, required: true }
          )}
        </div>
      </div>
      <hr className='below-hr' />
      <div className="d-flex justify-content-center">
        <button
          disabled={isLoading || !validateForm.response.is_passed}
          onClick={handleOnSubmit}
          type="button"
          className="mt-5 btn btn-primary cms-bg-color-primary cms-outline-primary"
        >
          <span className="font-weight-bold">
            {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
            Submit
          </span>
        </button>
      </div>
    </Modal.Body>
  );
}

TransferOwnershipModal.defaultProps = {
  transactionCode: 0
};

TransferOwnershipModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  transactionCode: PropTypes.number,
  createTransferApplication: PropTypes.instanceOf(Function).isRequired,
  getApplicationsList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  searchTdnSubdivision: PropTypes.instanceOf(Function).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  getOwnerList: PropTypes.instanceOf(Function).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  getTdn: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.CREATE_TRANSFER_APPLICATION) > -1,
  ownerList: _.get(api, `${c.GET_OWNER_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransferOwnershipModal);
